import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import RemoveIcon from '@mui/icons-material/Remove';

export const MaterialTransportOperation = {
  PICKUP: 'PICKUP',
  DELIVERY: 'DELIVERY',
};

export const MaterialTransportOperationList = [
  { label: 'Felvétel', value: MaterialTransportOperation.PICKUP, color: 'green' },
  { label: 'Lepakolás', value: MaterialTransportOperation.DELIVERY, color: 'red' },
];

export const MaterialTransportItemStatus = {
  COMPLETED: 'COMPLETED',
  MISSING: 'MISSING',
  PARTIAL: 'PARTIAL',
  PENDING: 'PENDING',
};

export const MaterialTransportItemStatusList = [
  { value: MaterialTransportItemStatus.PENDING, label: 'Függőben', color: 'white' },
  { value: MaterialTransportItemStatus.COMPLETED, label: 'Rendben', color: 'green' },
  { value: MaterialTransportItemStatus.MISSING, label: 'Nincs', color: 'red' },
  { value: MaterialTransportItemStatus.PARTIAL, label: 'Kevesebb', color: 'blue' },
];

export const MaterialTransportItemIcons = {
  [MaterialTransportItemStatus.COMPLETED]: <CheckIcon />,
  [MaterialTransportItemStatus.MISSING]: <CloseIcon />,
  [MaterialTransportItemStatus.PARTIAL]: <RemoveIcon />,
};

export const MaterialTransportView = {
  PENDING: 'PENDING',
  ALL: 'ALL',
};
